
export const calculateTeamCorners = (matches: any[], isHome?: boolean) => {
  let totalCorners = 0;
  const teamStats = new Map<string, { total: number; games: number }>();
  const thresholds = [0.5, 1.5, 2.5, 3.5, 4.5, 5.5, 6.5, 7.5, 8.5, 9.5, 10.5, 11.5, 12.5, 13.5, 14.5, 15.5];
  const overUnderCounts = thresholds.map(threshold => ({
    threshold,
    overCount: 0,
    underCount: 0
  }));

  matches.forEach(match => {
    let matchCorners = 0;
    
    if (isHome === true) {
      matchCorners = parseInt(match.HC) || 0;
      totalCorners += matchCorners;
      const team = match.HomeTeam;
      if (!teamStats.has(team)) {
        teamStats.set(team, { total: 0, games: 0 });
      }
      const stats = teamStats.get(team)!;
      stats.total += matchCorners;
      stats.games += 1;
    } else if (isHome === false) {
      matchCorners = parseInt(match.AC) || 0;
      totalCorners += matchCorners;
      const team = match.AwayTeam;
      if (!teamStats.has(team)) {
        teamStats.set(team, { total: 0, games: 0 });
      }
      const stats = teamStats.get(team)!;
      stats.total += matchCorners;
      stats.games += 1;
    } else {
      const homeCorners = parseInt(match.HC) || 0;
      const awayCorners = parseInt(match.AC) || 0;
      matchCorners = homeCorners + awayCorners;
      totalCorners += matchCorners;
      
      const homeTeam = match.HomeTeam;
      if (!teamStats.has(homeTeam)) {
        teamStats.set(homeTeam, { total: 0, games: 0 });
      }
      const homeStats = teamStats.get(homeTeam)!;
      homeStats.total += homeCorners;
      homeStats.games += 1;

      const awayTeam = match.AwayTeam;
      if (!teamStats.has(awayTeam)) {
        teamStats.set(awayTeam, { total: 0, games: 0 });
      }
      const awayStats = teamStats.get(awayTeam)!;
      awayStats.total += awayCorners;
      awayStats.games += 1;
    }

    overUnderCounts.forEach(count => {
      if (matchCorners > count.threshold) {
        count.overCount++;
      } else {
        count.underCount++;
      }
    });
  });

  let mostCorners = { team: '', average: 0 };
  let leastCorners = { team: '', average: Infinity };

  teamStats.forEach((stats, team) => {
    const average = stats.total / stats.games;
    if (average > mostCorners.average) {
      mostCorners = { team, average };
    }
    if (average < leastCorners.average) {
      leastCorners = { team, average };
    }
  });

  const totalGames = matches.length;
  const average = (totalCorners / totalGames).toFixed(2);

  const overUnderStats = overUnderCounts.map(({ threshold, overCount }) => ({
    threshold,
    overPercentage: ((overCount / totalGames) * 100).toFixed(1)
  }));

  return {
    totalCorners,
    average,
    most: { team: mostCorners.team, value: mostCorners.average },
    least: { team: leastCorners.team, value: leastCorners.average },
    overUnderStats
  };
};
